import {
    MenuActions,
    getActionFromKey,
    getIndexByLetter,
    getUpdatedIndex,
    isScrollable,
    maintainScrollVisibility
} from './combobox-utils';

/*
 * Read-only select code
 */
const Select = function (el, options) {
    // element refs
    this.el = el;
    this.comboEl = el.querySelector('[role=combobox]');
    this.valueEl = this.comboEl.querySelector('span');
    this.listboxEl = el.querySelector('[role=listbox]');

    // data
    this.idBase = this.comboEl.id;
    this.options = options;

    // state
    this.activeIndex = 0;
    this.open = false;
    this.searchString = '';
    this.searchTimeout = null;
    this.postValue = el.querySelector('[js-combobox-post-value]');

    this.hasInitValue = !!this.valueEl.innerHTML;
}

Select.prototype.init = function () {
    this.comboEl.addEventListener('blur', this.onComboBlur.bind(this));
    this.comboEl.addEventListener('click', () => this.updateMenuState(true));
    this.comboEl.addEventListener('keydown', this.onComboKeyDown.bind(this));

    this.valueEl.innerHTML = this.options[0][1] || '';

    if (!!this.valueEl.innerHTML) {
        //if label is set, make sure value same value is set in postValue input  
        this.postValue.value = this.options[0][0];
    }

    this.options.map(([value, label], index) => {
        const optionEl = document.createElement('div');
        optionEl.setAttribute('role', 'option');
        optionEl.id = `${this.idBase}-${index}`;
        optionEl.className = index === 0 ? 'combo-option option-current' : 'combo-option';
        optionEl.setAttribute('aria-selected', `${index === 0}`);
        optionEl.innerText = label;
        if(value) {
            optionEl.setAttribute('value', value)
        }

        optionEl.addEventListener('click', (event) => {
            event.stopPropagation();
            this.onOptionClick(index);
        });
        optionEl.addEventListener('mousedown', this.onOptionMouseDown.bind(this));
        this.listboxEl.appendChild(optionEl);
    });
}

Select.prototype.getSearchString = function (char) {
    if (typeof this.searchTimeout === 'number') {
        window.clearTimeout(this.searchTimeout);
    }

    this.searchTimeout = window.setTimeout(() => {
        this.searchString = '';
    }, 1000);

    this.searchString += char;
    return this.searchString;
}

Select.prototype.onComboKeyDown = function (event) {
    const { key } = event;
    const max = this.options.length - 1;

    const action = getActionFromKey(event, this.open);

    switch (action) {
        case MenuActions.Next:
        case MenuActions.Last:
        case MenuActions.First:
        case MenuActions.Previous:
            event.preventDefault();
            return this.onOptionChange(getUpdatedIndex(this.activeIndex, max, action));
        case MenuActions.CloseSelect:
        case MenuActions.Space:
            event.preventDefault();
            this.selectOption(this.activeIndex);
        case MenuActions.Close:
            event.preventDefault();
            return this.updateMenuState(false);
        case MenuActions.Type:
            this.updateMenuState(true);
            console.log('type');
            var searchString = this.getSearchString(key);
            return this.onOptionChange(Math.max(0, getIndexByLetter(this.options, searchString)));
        case MenuActions.Open:
            event.preventDefault();
            return this.updateMenuState(true);
    }
}

Select.prototype.onComboBlur = function () {
    if (this.ignoreBlur) {
        this.ignoreBlur = false;
        return;
    }

    if (this.open) {
        this.selectOption(this.activeIndex);
        this.updateMenuState(false, false);
    }
}

Select.prototype.onOptionChange = function (index) {
    this.activeIndex = index;
    this.comboEl.setAttribute('aria-activedescendant', `${this.idBase}-${index}`);

    // update active style
    const options = this.el.querySelectorAll('[role=option]');
    [...options].forEach((optionEl) => {
        optionEl.classList.remove('option-current');
    });
    options[index].classList.add('option-current');

    if (isScrollable(this.listboxEl)) {
        maintainScrollVisibility(options[index], this.listboxEl);
    }
}

Select.prototype.onOptionClick = function (index) {
    this.onOptionChange(index);
    this.selectOption(index);
    this.updateMenuState(false);
}

Select.prototype.onOptionMouseDown = function () {
    this.ignoreBlur = true;
}

Select.prototype.selectOption = function (index) {
    const [value, label] = this.options[index];
    this.valueEl.innerHTML = label;
    this.postValue.value = value;

    this.activeIndex = index;

    // update aria-selected
    const options = this.el.querySelectorAll('[role=option]');
    [...options].forEach((optionEl) => {
        optionEl.setAttribute('aria-selected', 'false');
    });
    options[index].setAttribute('aria-selected', 'true');
}

Select.prototype.updateMenuState = function (open, callFocus = true) {
    this.open = open;

    this.comboEl.setAttribute('aria-expanded', `${open}`);
    open ? this.el.classList.add('open') : this.el.classList.remove('open');
    callFocus && this.comboEl.focus();

    // update activedescendant
    const activeID = open ? `${this.idBase}-${this.activeIndex}` : this.valueEl.id;
    this.comboEl.setAttribute('aria-activedescendant', activeID);
}

export default Select;


/* HTML example
<label id="combo1-label" class="combo-label">Read-only Select Example</label>
<div class="combo js-select">
    <div
        id="combo1"
        class="combo-input"
        role="combobox"
        tabindex="0"
        aria-activedescendant="combo1-value"
        aria-autocomplete="none"
        aria-haspopup="listbox"
        aria-expanded="false"
        aria-controls="listbox1"
    >
        <span class="combo1-value" id="combo1-value"></span>
    </div>
    <ul class="combo-menu" role="listbox" id="listbox1"></ul>
</div>
*/